import * as React from 'react'
import { Col, Row, Spin } from 'antd'

export default function Loader() {
    return (
        <Row style={{ height: '100vh', textAlign: 'center' }} justify={'center'}>
            <Col span={8}></Col>
            <Col span={8} style={{ alignItems: 'center' }}>
                <Spin size={'large'} style={{ paddingTop: '49vh' }} />
            </Col>
            <Col span={8}></Col>
        </Row>
    )
}
